import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { OnboardingEmptyStatesInfoSize } from '../models/empty-state-size.enum';
import { OnboardingEmptyStatesOptions } from './../models/empty-state-options.enum';

@Component({
  selector: 'f-onboarding-empty-state',
  templateUrl: './onboarding-empty-state.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class FireflyOnboardingEmptyStateComponent {
  @Input() caption = '';
  @Input() info = '';
  @Input() note = '';
  @Input() onboardingOption!: OnboardingEmptyStatesOptions;
  @Input() infoTitleSize: OnboardingEmptyStatesInfoSize = OnboardingEmptyStatesInfoSize.Sm;
}
